import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconCalendar from '@spothero/icons/calendar';
import Label from '@spothero/ui/label';
import TextInput from '@spothero/ui/text-input';

const AirportDateRangePickerInputs = ({
    startPlaceholderText,
    endPlaceholderText,
    startLabelText,
    endLabelText,
    displayFormat,
    selectedStartDate,
    selectedEndDate,
    adjustStartOrEnd,
    invalidStartDate,
    invalidEndDate,
    onStartInputFocus,
    onEndInputFocus,
}) => {
    const startInputClasses = classNames(
        'AirportDateRangePickerInputs-input',
        'AirportDateRangePickerInputs-start',
        {
            'AirportDateRangePickerInputs-selected':
                adjustStartOrEnd === 'start',
            'AirportDateRangePickerInputs-with-value': Boolean(
                selectedStartDate
            ),
            'AirportDateRangePickerInputs-error': invalidStartDate,
        }
    );
    const endInputClasses = classNames(
        'AirportDateRangePickerInputs-input',
        'AirportDateRangePickerInputs-end',
        {
            'AirportDateRangePickerInputs-selected': adjustStartOrEnd === 'end',
            'AirportDateRangePickerInputs-with-value': Boolean(selectedEndDate),
            'AirportDateRangePickerInputs-error': invalidEndDate,
        }
    );
    const startInputDisplay =
        displayFormat && selectedStartDate
            ? displayFormat(selectedStartDate)
            : selectedStartDate;
    const endInputDisplay =
        displayFormat && selectedEndDate
            ? displayFormat(selectedEndDate)
            : selectedEndDate;

    return (
        <div className="AirportDateRangePickerInputs">
            <div className={startInputClasses}>
                <TextInput
                    name="AirportDateRangePickerInputs-start"
                    label={
                        <Label onClick={onStartInputFocus}>
                            {startLabelText}
                        </Label>
                    }
                    defaultValue={startInputDisplay}
                    onFocus={onStartInputFocus}
                    icon={<IconCalendar className="Icon-calendar" />}
                    iconPosition="right"
                    placeholder={startPlaceholderText}
                    readOnly
                />
            </div>
            <div className={endInputClasses}>
                <TextInput
                    name="AirportDateRangePickerInputs-end"
                    label={
                        <Label onClick={onEndInputFocus}>{endLabelText}</Label>
                    }
                    defaultValue={endInputDisplay}
                    onFocus={onEndInputFocus}
                    icon={<IconCalendar className="Icon-calendar" />}
                    iconPosition="right"
                    placeholder={endPlaceholderText}
                    readOnly
                />
            </div>
        </div>
    );
};

AirportDateRangePickerInputs.propTypes = {
    startPlaceholderText: PropTypes.string,
    endPlaceholderText: PropTypes.string,
    startLabelText: PropTypes.string,
    endLabelText: PropTypes.string,
    displayFormat: PropTypes.func,
    selectedStartDate: PropTypes.string,
    selectedEndDate: PropTypes.string,
    adjustStartOrEnd: PropTypes.string,
    invalidStartDate: PropTypes.bool,
    invalidEndDate: PropTypes.bool,
    onStartInputFocus: PropTypes.func,
    onEndInputFocus: PropTypes.func,
};

AirportDateRangePickerInputs.defaultProps = {
    startPlaceholderText: 'Select Parking Start Date',
    endPlaceholderText: 'Select Parking End Date',
    startLabelText: 'Parking Start Date',
    endLabelText: 'Parking End Date',
};

export default AirportDateRangePickerInputs;
